export enum PlatformResourceType {
  LogoEmail = "LogoEmail",
  LeftMenuLogo = "LeftMenuLogo",
  TopMenuLogo = "TopMenuLogo",
  LogoV4dark = "LogoV4dark",
  LogoV4light = "LogoV4light",
}
